import { createFileRoute } from "@tanstack/react-router";
import LoadingPage from "lib/components/layout/LoadingPage";
import withAuthentication from "../../components/withAuthentication";

/**
 * Builder-facing preview of a community or master plan. CTA / save UI hidden.
 */
function ShowroomPreview() {
  return <LoadingPage pageTitle="Showroom" />;
}

export const Route = createFileRoute("/showroom/preview")({
  component: withAuthentication(ShowroomPreview, {
    features: ["showroomUnification"],
    products: ["showroom"],
  }),
});
